// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tdx-navigation-layout[data-v-106ae4a6]{overflow:hidden}.tdx-navigation-layout__content-description[data-v-106ae4a6]{max-width:49.0625rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
